export const auth = {
  title: "Grizzly Industries",
  subtitle: "Shop operations sign-in",
  email: "Email",
  passwordLabel: "Password",
  signIn: "Sign in",
  signingIn: "Signing in…",
  unreachable: "Cannot reach the shop server. Check the connection and try again.",
  demoHint:
    "Development accounts: owner@grizzly.local, office@grizzly.local, operator@grizzly.local (password Grizzly!dev123)",
};
